/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MemberBodyMetricType = 'Weight' | 'BodyFatMass' | 'BodyFatPercentage' | 'SkeletalMuscleMass' | 'BodyMassIndex' | 'DegreeOfObesity' | 'TotalBodyWater' | 'IntracellularWater' | 'ExtracellularWater' | 'VisceralFatLevel' | 'BasalMetabolicRate' | 'ProteinMass' | 'MineralMass' | 'BodyCellMass' | 'WaistCircumference' | 'WaistHipRatio' | 'ECWTBWRatio' | 'MuscleMassRightArm' | 'MuscleMassLeftArm' | 'MuscleMassTrunk' | 'MuscleMassRightLeg' | 'MuscleMassLeftLeg';

export const MemberBodyMetricType = {
    Weight: 'Weight' as MemberBodyMetricType,
    BodyFatMass: 'BodyFatMass' as MemberBodyMetricType,
    BodyFatPercentage: 'BodyFatPercentage' as MemberBodyMetricType,
    SkeletalMuscleMass: 'SkeletalMuscleMass' as MemberBodyMetricType,
    BodyMassIndex: 'BodyMassIndex' as MemberBodyMetricType,
    DegreeOfObesity: 'DegreeOfObesity' as MemberBodyMetricType,
    TotalBodyWater: 'TotalBodyWater' as MemberBodyMetricType,
    IntracellularWater: 'IntracellularWater' as MemberBodyMetricType,
    ExtracellularWater: 'ExtracellularWater' as MemberBodyMetricType,
    VisceralFatLevel: 'VisceralFatLevel' as MemberBodyMetricType,
    BasalMetabolicRate: 'BasalMetabolicRate' as MemberBodyMetricType,
    ProteinMass: 'ProteinMass' as MemberBodyMetricType,
    MineralMass: 'MineralMass' as MemberBodyMetricType,
    BodyCellMass: 'BodyCellMass' as MemberBodyMetricType,
    WaistCircumference: 'WaistCircumference' as MemberBodyMetricType,
    WaistHipRatio: 'WaistHipRatio' as MemberBodyMetricType,
    EcwtbwRatio: 'ECWTBWRatio' as MemberBodyMetricType,
    MuscleMassRightArm: 'MuscleMassRightArm' as MemberBodyMetricType,
    MuscleMassLeftArm: 'MuscleMassLeftArm' as MemberBodyMetricType,
    MuscleMassTrunk: 'MuscleMassTrunk' as MemberBodyMetricType,
    MuscleMassRightLeg: 'MuscleMassRightLeg' as MemberBodyMetricType,
    MuscleMassLeftLeg: 'MuscleMassLeftLeg' as MemberBodyMetricType
};

